import React from 'react';
import './ScrollToTop.css'; // Import the CSS for styles

const ScrollToTop = () => {
  // Scroll function that scrolls to the top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="scroll-container">
      {/*<div className="scroll-text">*/}
      {/*  <p>UNE</p>*/}
      {/*  <p>ARCHITECTURE</p>*/}
      {/*  <p>ACTUELLE</p>*/}
      {/*  <p>ET</p>*/}
      {/*  <p>DURABLE</p>*/}
      {/*</div>*/}
      <div className="scroll-arrow" onClick={scrollToTop}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          className="arrow-icon"
          fill="none"
          stroke="#d3d3d3"
          strokeWidth="10"
        >
          <polyline points="7.5,90 45,45 82.5,90"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default ScrollToTop;